<template>
    <Checkbox
        binary
        v-model="localChecked"
        :indeterminate="localPartial"
        :disabled="localDisabled || localReadonly"
        :input-id="checkboxId"
        :invalid="localError || localDuplicate"
        @change="onChange" />
</template>

<script>
import { defineComponent, ref, watch } from 'vue';
import Checkbox from 'primevue/checkbox';

export default defineComponent({
    name: 'TreeCheckbox',
    components: { Checkbox },
    props: {
        checked: { type: Boolean, default: false },
        partial: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        duplicate: { type: Boolean, default: false },
        error: { type: Boolean, default: false }
    },
    emits: ['change'],
    setup(props, { emit }) {
        // local model for v-model
        const localChecked = ref(props.checked);
        const localPartial = ref(props.partial);
        const localDisabled = ref(props.disabled);
        const localReadonly = ref(props.readonly);
        const localDuplicate = ref(props.duplicate);
        const localError = ref(props.error);

        // keep in sync when parent flips `checked`
        watch(
            () => props.checked,
            (newVal) => {
                localChecked.value = newVal;
            }
        );
        watch(
            () => props.partial,
            (newVal) => {
                localPartial.value = newVal;
            }
        );
        watch(
            () => props.disabled,
            (newVal) => {
                localDisabled.value = newVal;
            }
        );
        watch(
            () => props.readonly,
            (newVal) => {
                localReadonly.value = newVal;
            }
        );
        watch(
            () => props.duplicate,
            (newVal) => {
                localDuplicate.value = newVal;
            }
        );
        watch(
            () => props.error,
            (newVal) => {
                localError.value = newVal;
            }
        );

        // unique ID for <label for="..."> if you need one
        const checkboxId = 'tc-' + Math.random().toString(36).slice(2, 10);

        // re-emit the boolean checked state
        function onChange(e) {
            // e.checked is the new boolean
            emit('change', e.checked);
        }

        return {
            localChecked,
            partial: props.partial,
            disabled: props.disabled,
            readonly: props.readonly,
            duplicate: props.duplicate,
            error: props.error,
            localPartial,
            localDisabled,
            localReadonly,
            localDuplicate,
            localError,
            checkboxId,
            onChange
        };
    }
});
</script>

<style scoped>
/* If you want the red border on invalid/duplicate: */
.p-invalid .p-checkbox-box {
    border-color: #f56565 !important;
}
</style>
